/** Same convention as web/src/utils/deviceFingerprint.js -- stable per-browser
 * identifier sent as X-Device-Fingerprint on every request. */
const STORAGE_KEY = "beekeeper-admin.device_fingerprint";

export function getDeviceFingerprint() {
  let fingerprint = localStorage.getItem(STORAGE_KEY);
  if (!fingerprint) {
    fingerprint = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, fingerprint);
  }
  return fingerprint;
}
